import React, { useState, useRef, useEffect } from 'react';
import './Logs.css';
import success from '../../image/tick.png';
import error from '../../assets/img/status/error.jpg';
import { constantMapping, constColorMapping } from './constant';
import { LogRowProps } from './reportAndLogsRowTypes';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { fetchAndDownloadReport, getSyncStatus } from '../../services/reportService';
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry';
import { Loader } from '../loader/Loader';

const CUR_COMPONENT = "Report And Logs"
const CUR_COMPONENT_COMMON="commonPortal";
const ReportAndLogsRow = (props: LogRowProps) => {
    const {translate} = usePortalTranslation();
    const [show, setShow] = useState(false);
    const reportLink = useRef<HTMLAnchorElement | null>(null)
    const downloadFileLink = useRef<HTMLAnchorElement | null>(null)
    const [syncStatus, setSyncStatus] = useState<string | null>(null);
    const [filePath, setFilePath] = useState<string | null>(null);

    const reportDownloadHandler = async ()=>{
        const entityName = props.entityName;
        if(entityName && entityName === "promoentity") {
            if (!filePath) {
                setSyncStatus("FAILURE");
                throw new Error("No file path found for selected task");
            }

            const baseUrl = EnvironmentRegistry.getServerUrl();
            const encodedPath = encodeURIComponent(filePath);
            const reportUrl = `${baseUrl}/v1/download/mdmkafkauploads?filepath=${encodedPath}`;
            await fetchAndDownloadReport(reportUrl);
        } else {
            const url = (props.statusReport);
            fetchAndDownloadReport(url);
        }
    }

    const downloadFileHandler = ()=>{
        const url =( props.filePath);
        fetchAndDownloadReport(url);
    }

    function ErrorLog(){
        if(props.summary&&props.description){

            return(
                <>
                {<h5>{props.summary}</h5> && <h6>{props.description}</h6>}
                </>
            );

        }
        else{
            return(
                <>
                {<h5> {translate(TranslationEnum.common_portal,"No Data Available")} </h5>}
                </>
            );
        }
    }

    useEffect(() => {
        const fetchSyncStatus = async () => {
            if (props.entityName === "promoentity" && props.id) {
                try {
                    const response = await getSyncStatus(props.id);
                    if (response.status !== 200 || !response.data) {
                        setSyncStatus("FAILURE");
                        return;
                    }
                    setSyncStatus(response?.data?.data[0]?.summary_status); 
                    setFilePath(response?.data?.data[0]?.failure_file_paths[0])
                } catch (error) {
                    console.error("Failed to fetch sync status", error);
                }
            }
        };

        fetchSyncStatus();
    }, [props.entityName, props.id]);

    const shouldShowIcon = () => {
        if (props.entityName === "promoentity") {
            return syncStatus === "SUCCESS" || syncStatus === "FAILURE" || syncStatus === "PARTIAL";
        } else {
            return true;
        }
    };
    
    const getStatusIcon = () => {
        if (props.entityName === "promoentity") {
            return syncStatus === "SUCCESS" ? success : error;
        } else {
            return props.status === 200 ? success : error;
        }
    };
    

    return (
        <>
            <div className="logs-row" style={{flexDirection:"column"}}>
                <>
                    <div className="logs-heading">
                        <div className="log-index">
                            {props.logIndex}
                        </div>
                        <div className="logs-type" style={{backgroundColor:constColorMapping[props.type], color: props.type? "black" : "white" }}>
                            {constantMapping[props.type]?translate(TranslationEnum.report_and_logs,constantMapping[props.type]) : translate(TranslationEnum.report_and_logs,"Not Available")}
                        </div>
                    </div>
                    <div className="logs-entity">

                        <div className="logs-entity-name">
                            <p className="logs-reports-entity-name"> {translate(TranslationEnum.report_and_logs,props.entityName)} </p>
                        </div>

                        <div className="logs-last-modified-time">
                            <p className="last-modified-time">{props.lastModifiedTime}</p>
                        </div>

                    </div>
                    <div className="logs-btn">
                        <div className='show-log-report'>
                            {props.filePath !== null && props.mdmType !== "mdmupload" && props.mdmType !== "mdmkafkaupload" && <div>
                                <button className='download-file-btn' onClick={downloadFileHandler}>{translate(TranslationEnum.report_and_logs,"DOWNLOAD FILE")}</button>
                                <a href="/#" ref={downloadFileLink} hidden>download link</a>
                            </div>}
                            <div className="show-log-btn">
                                <button onClick={() => setShow(!show)} className="log-button">{translate(TranslationEnum.report_and_logs,"SHOW LOGS")}</button>
                            </div>
                            {(props.statusReport != null || props.entityName === "promoentity") && <div>
                                <button className="report-button" onClick={reportDownloadHandler}>{translate(TranslationEnum.report_and_logs,"REPORT")}</button>
                                <a  href = "/#" ref={reportLink} hidden >report link</a>
                            </div>
                            }

                        </div>
                        <div>
                            {shouldShowIcon() ? (
                                <img className="conf" src={getStatusIcon()} alt="status" />
                            ) : (
                                <Loader size={'lg'} variant={"oval"} style={{ marginRight: 25, marginBottom: 5 }}/>
                            )}     
                        </div>

                    </div>
                    <div className="collapse-show">
                           {show && <ErrorLog/>}
                    </div>
                </>
            </div>
        </>

    );
}

export default ReportAndLogsRow;